export const routes = [
  {
    path: 'agente-marketing',
    name: 'talkvia_marketing_agent',
    meta: { permissions: ['administrator'] },
    component: () => import('./Index.vue'),
  },
];
